// Pilihan dan pewarnaan indikator Early Warning System (EWS).
// Dipakai bersama oleh Master Data (pengisian) dan running text Buat Pesanan.

export const EWS_STATUS = [
  "Sangat Rendah",
  "Rendah",
  "Normal",
  "Waspada",
  "Tinggi",
  "Sangat Tinggi",
];

export const HET_STATUS = ["Dalam Rentang", "Di Atas", "Di Bawah"];

// Skala warna mengikuti tingkat kewaspadaan: biru (rendah) → merah (tinggi).
const WARNA_EWS = {
  "Sangat Rendah": "bg-blue-100 text-blue-800 border-blue-200",
  "Rendah": "bg-sky-100 text-sky-800 border-sky-200",
  "Normal": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Waspada": "bg-amber-100 text-amber-800 border-amber-200",
  "Tinggi": "bg-orange-100 text-orange-800 border-orange-200",
  "Sangat Tinggi": "bg-red-100 text-red-800 border-red-200",
};

const NETRAL = "bg-slate-100 text-slate-600 border-slate-200";

// Varian untuk elemen <select>/<input>: kelas .kedan-input didefinisikan setelah
// utilitas Tailwind sehingga warnanya harus dipaksa dengan modifier "!".
// Ditulis literal (bukan hasil rangkaian string) agar ikut terbaca Tailwind.
const WARNA_EWS_INPUT = {
  "Sangat Rendah": "!bg-blue-50 !text-blue-900 !border-blue-300",
  "Rendah": "!bg-sky-50 !text-sky-900 !border-sky-300",
  "Normal": "!bg-emerald-50 !text-emerald-900 !border-emerald-300",
  "Waspada": "!bg-amber-50 !text-amber-900 !border-amber-300",
  "Tinggi": "!bg-orange-50 !text-orange-900 !border-orange-300",
  "Sangat Tinggi": "!bg-red-50 !text-red-900 !border-red-300",
};

const WARNA_HET_INPUT = {
  "Dalam Rentang": "!bg-emerald-50 !text-emerald-900 !border-emerald-300",
  "Di Atas": "!bg-red-50 !text-red-900 !border-red-300",
  "Di Bawah": "!bg-blue-50 !text-blue-900 !border-blue-300",
};

export const warnaEws = (status) => WARNA_EWS[status] || NETRAL;
export const warnaEwsInput = (status) => WARNA_EWS_INPUT[status] || "";
export const warnaHetInput = (status) => WARNA_HET_INPUT[status] || "";

/** Rangkuman HET/HAP lengkap dengan labelnya, mis. "12,5% Di Atas HET/HAP". */
export function ringkasHet(persen, status) {
  const bagian = [persen, status, "HET/HAP"].filter(Boolean);
  // Hanya label saja (tanpa persentase dan status) berarti belum diisi.
  return bagian.length > 1 ? bagian.join(" ") : "";
}

// Ikon tiap komoditas EWS.
//
// Berkasnya disimpan lokal di frontend/public/ews/ dan dibuat khusus untuk
// aplikasi ini — tidak mengambil dari layanan luar, sehingga tidak menambah
// domain yang perlu di-whitelist firewall, tetap tampil saat internet terputus,
// dan bebas kewajiban atribusi lisensi pihak ketiga.
//
// Ingin mengganti dengan berkas lain (mis. unduhan Flaticon)? Timpa berkas SVG/PNG
// di folder tersebut atau ubah path di bawah. Nilai yang diawali "/" dirender
// sebagai <img>, selain itu diperlakukan sebagai emoji.
const IKON_KOMODITAS = {
  "Cabai Merah": "/ews/cabai-merah.svg",
  "Cabai Rawit": "/ews/cabai-rawit.svg",
  "Bawang Merah": "/ews/bawang-merah.svg",
  "Bawang Putih": "/ews/bawang-putih.svg",
  "Daging Ayam Ras": "/ews/daging-ayam.svg",
  "Daging Sapi": "/ews/daging-sapi.svg",
  "Telur Ayam Ras": "/ews/telur-ayam.svg",
  "Gula Pasir": "/ews/gula-pasir.svg",
  "Minyak Goreng": "/ews/minyak-goreng.svg",
  "Beras": "/ews/beras.svg",
};

export const ikonKomoditas = (nama) => IKON_KOMODITAS[nama] || "📦";
